import 'antd-mobile-v2/dist/antd-mobile.min.css'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './assets/style/index.scss'
import './flexible'
import reportWebVitals from './reportWebVitals'
import CommonService from "@service/commonService";
import Holiday from "@component/Holiday";


CommonService.holidayValidate().then(rs => rs.data).then(rs => {
	if (rs.errcode == 1000) {
		// 登录
		return ReactDOM.render(
			<React.Fragment>
				<Holiday time={rs.errmsg}/>
			</React.Fragment>,
			document.getElementById('root')
		)
	}
	ReactDOM.render(
		<React.Fragment>
			<App/>
		</React.Fragment>,
		document.getElementById('root')
	)

}).catch(e => {
	ReactDOM.render(
		<React.Fragment>
			<App/>
		</React.Fragment>,
		document.getElementById('root')
	)
})


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
